const translate = {
  // about page details
  about: {
    title: "aboutTitle",
  },
  todo: {
    user: "todoUser",
    postedBy: "todoPostedBy",
    comments: "todoComments",
  },
}

export default translate
